module.exports = "img/2.e472ea.jpg";